define('shared/initializer/form/adapters/ResetPassword',[
        '$',
        '../constants',
        './Bootstrap3',
        './mixins/ProtocolGuarantee',
        './mixins/LabelFloatable',
        './mixins/Ajaxable',
        './mixins/SubmissionLockable',
        './mixins/AfterSubmitActionTriggerable',
        './mixins/fields/ConfirmPassword',
        './mixins/ThrobberOnBeforeSubmit',
        './mixins/fields/PasswordLengthValidation',
        'shared/lib/ctor',
        'shared/util/dispatchers/FormDataDispatcher',
        'shared/lib/RSVP',
        'shared/lib/URI',
        'shared/util/state',
        'shared/my/cmus',
        'shared/page/partner',
        'shared/lib/console',
        'shared/util/state/adapters/form'
    ],
    function (
        $,
        constants,
        Bootstrap3Adapter,
        ProtocolGuarantee,
        LabelFloatable,
        Ajaxable,
        SubmissionLockable,
        AfterSubmitActionTriggerable,
        ConfirmPasswordField,
        ThrobberOnBeforeSubmit,
        PasswordLengthValidationField,
        ctor,
        FormDataDispatcher,
        RSVP,
        URI,
        state,
        getCMus,
        getPartner,
        console,
        formAdapter
    ) {
        'use strict';

        var URL_BASE = '/services/commerce-v4/membermanager/';

        var Ctor = ctor(function() {
            var me = this;

            me.base.apply(me, arguments);
            me.mixin(
                Ajaxable,
                ProtocolGuarantee,
                LabelFloatable,
                ThrobberOnBeforeSubmit,
                ConfirmPasswordField,
                SubmissionLockable,
                AfterSubmitActionTriggerable,
                PasswordLengthValidationField
            );

        }).inherit(Bootstrap3Adapter);

        var p = Ctor.prototype;

        p.doPageLoad = function() {
            var me = this;

            var dispatcher = new FormDataDispatcher(me.$form);
            return dispatcher.dispatch(
                {
                    items:
                    {
                        'token':
                        {
                            allowUndefined: true,
                            sources: [{type: 'query', key: 'token'}],
                            targets: [{type: 'form', key: 'token'}]
                        }
                    }
                })
                .then(function(){
                    var uri = new URI(window.location.href);
                    if(uri.query(true).token){
                        return new RSVP.Promise(function(resolve, reject){
                            var dfd = $.ajax({
                                url: URL_BASE + 'GetResetPasswordInfo',
                                type: 'POST',
                                data: {
                                    token: uri.query(true).token
                                },
                                dataType: 'json'
                            });

                            dfd.then(
                                function(data){
                                    if (!data.Success || !data.Result || !data.Result.IsValid) {
                                        emitInvalidLinkError(me, 'token is invalid.');
                                        me.disable();
                                    }

                                    resolve();
                                },
                                reject);
                        });
                    }
                    else{
                        emitInvalidLinkError(me, 'token is missing.');
                        me.disable();
                        return RSVP.resolve();
                    }
                });
        };

        function emitInvalidLinkError(me, message){
            var err = new Error(message);
            err.type = 'reset.password.link.invalid';
            err.fatal = true;
            me.emit('error', err);
        }

        p.doAfterSubmit = function( data ){
            var me = this;
            console.log('ResetPassword doBeforeRedirect received data:', data);

            if(data.Success && data.Result && data.Result.IsSucceed){
                return state.adapters.add(formAdapter)
                    .then(function(){
                        return state.push( 'form.email', data.Result.Email);
                    })
                    .then(function(){
                        if(typeof me.resume === 'function'){
                            return me.resume();
                        }
                    })
                    .then(function(){
                        me.disable();
                    });
            }
            else{
                var err = new Error('Something went wrong when resetting password.');
                err.type = 'generic';
                return RSVP.reject(err);
            }
        };

        return Ctor;
    });

